/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Muscles_Why_LightInputs */

const en_us2_progress_muscles_why_light = /** @type {(inputs: Progress_Muscles_Why_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The black line is your plan's weekly target, the volume the research supports for building muscle.`)
};

const pt_br2_progress_muscles_why_light = /** @type {(inputs: Progress_Muscles_Why_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A linha preta é a meta semanal do seu plano, o volume que os estudos sustentam para ganhar massa.`)
};

const es_419_progress_muscles_why_light = /** @type {(inputs: Progress_Muscles_Why_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La línea negra es la meta semanal de tu plan, el volumen que respaldan los estudios para ganar músculo.`)
};

const pt_pt2_progress_muscles_why_light = /** @type {(inputs: Progress_Muscles_Why_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A linha preta é o objetivo semanal do teu plano, o volume que os estudos sustentam para ganhar massa muscular.`)
};

const fr_fr2_progress_muscles_why_light = /** @type {(inputs: Progress_Muscles_Why_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La ligne noire est l'objectif hebdomadaire de ton programme, le volume que la recherche soutient pour prendre du muscle.`)
};

const de_de2_progress_muscles_why_light = /** @type {(inputs: Progress_Muscles_Why_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die schwarze Linie ist das Wochenziel deines Plans, das Volumen, das die Forschung für Muskelaufbau stützt.`)
};

const it_it2_progress_muscles_why_light = /** @type {(inputs: Progress_Muscles_Why_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La linea nera è l'obiettivo settimanale della tua scheda, il volume che la ricerca sostiene per costruire muscolo.`)
};

/**
* | output |
* | --- |
* | "The black line is your plan's weekly target, the volume the research supports for building muscle." |
*
* @param {Progress_Muscles_Why_LightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_muscles_why_light = /** @type {((inputs?: Progress_Muscles_Why_LightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Muscles_Why_LightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_muscles_why_light(inputs)
	if (locale === "es-419") return es_419_progress_muscles_why_light(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_muscles_why_light(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_muscles_why_light(inputs)
	if (locale === "de-DE") return de_de2_progress_muscles_why_light(inputs)
	if (locale === "it-IT") return it_it2_progress_muscles_why_light(inputs)
	return en_us2_progress_muscles_why_light(inputs)
});
export { progress_muscles_why_light as "progress.muscles_why_light" }